import { RewardsApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { CORE_API_URL } = process.env;

export default new RewardsApi(CORE_API_URL, {}, olyEngineApi);
